var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo",on:{"click":_vm.hideMenu}},[(_vm.link)?_c('router-link',{attrs:{"to":_vm.link}},[_c('LogoSvg')],1):_vm._e(),(!_vm.link)?_c('LogoSvg'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }